/**
 * Substrings (case-insensitive) that identify recorder / notetaker bots in participant display names.
 *
 * Examples:
 * - "Rithmo Chief of Staff", "Rithmo Transcription", "Recall.ai", "Zoom Bot"
 * - "Fireflies.ai Notetaker Jane Doe" (Fireflies meeting notetaker)
 *
 * Used when setting `isBot` on upsert, filtering UI counts, and analytics — aligned across
 * C++ roster sync, Zoom app participant list, and web dashboard.
 *
 * @module shared/knownBotsDisplayName
 */

/** Lowercase substrings; match if `displayName.toLowerCase().includes(substring)`. */
export const KNOWN_BOT_DISPLAY_NAME_SUBSTRINGS = [
  'rithmo',
  'recall',
  'zoom bot',
  /** Fireflies.ai Notetaker <name> */
  'fireflies',
] as const;

export function isKnownBotDisplayName(displayName: string | null | undefined): boolean {
  const n = String(displayName ?? '').toLowerCase().trim();
  if (!n) return false;
  return KNOWN_BOT_DISPLAY_NAME_SUBSTRINGS.some((s) => n.includes(s));
}
